"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _core = require("@material-ui/core");

var _clsx2 = _interopRequireDefault(require("clsx"));

var _propTypes = require("prop-types");

var _react = _interopRequireDefault(require("react"));

var _useStyles = _interopRequireDefault(require("../useStyles"));

var _excluded = ["children", "description", "link", "linkComponent", "name", "selected", "title", "variant"];

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function Contents(_ref) {
  var children = _ref.children,
      description = _ref.description,
      link = _ref.link,
      linkComponent = _ref.linkComponent,
      name = _ref.name,
      selected = _ref.selected,
      title = _ref.title,
      variant = _ref.variant,
      props = _objectWithoutProperties(_ref, _excluded);

  var classes = (0, _useStyles["default"])(props);
  var LinkComponent = link && (linkComponent || _core.Button);
  var theme = (0, _core.useTheme)();
  var isDesktop = (0, _core.useMediaQuery)(theme.breakpoints.up("md"));
  var hasContents = name || title || description || link;
  var showTitle = !isDesktop || variant === "story";
  var showDescription = !isDesktop || variant === "story";
  var showLink = !isDesktop || variant === "story";

  if (!hasContents) {
    return null;
  }

  return /*#__PURE__*/_react["default"].createElement(_core.Grid, {
    container: true,
    alignContent: "space-between",
    className: classes.contents
  }, /*#__PURE__*/_react["default"].createElement(_core.Grid, {
    item: true,
    xs: 12,
    container: true
  }, name && name.length > 0 && /*#__PURE__*/_react["default"].createElement(_core.Grid, {
    item: true,
    xs: 12,
    className: classes.content
  }, /*#__PURE__*/_react["default"].createElement(_core.Typography, {
    variant: "button",
    className: (0, _clsx2["default"])(classes.name, _defineProperty({}, classes.nameSelected, selected))
  }, name)), title && title.length > 0 && showTitle && /*#__PURE__*/_react["default"].createElement(_core.Grid, {
    item: true,
    xs: 12,
    className: classes.content
  }, /*#__PURE__*/_react["default"].createElement(_core.Typography, {
    variant: "subtitle2",
    className: classes.title
  }, title)), description && description.length > 0 && showDescription && /*#__PURE__*/_react["default"].createElement(_core.Grid, {
    item: true,
    xs: 12,
    className: classes.content
  }, /*#__PURE__*/_react["default"].createElement(_core.Typography, {
    variant: "caption",
    className: classes.description
  }, description)), link && link.url && showLink && /*#__PURE__*/_react["default"].createElement(_core.Grid, {
    item: true,
    xs: 12,
    className: classes.content
  }, /*#__PURE__*/_react["default"].createElement(LinkComponent, {
    href: link.url,
    variant: "outlined",
    size: "small",
    className: classes.link
  }, link.title || link.url))), children && /*#__PURE__*/_react["default"].createElement(_core.Grid, {
    item: true,
    xs: 12,
    className: classes.content
  }, children));
}

Contents.propTypes = {
  children: _propTypes.PropTypes.node,
  description: _propTypes.PropTypes.string,
  link: _propTypes.PropTypes.shape({
    url: _propTypes.PropTypes.string.isRequired,
    title: _propTypes.PropTypes.string
  }),
  linkComponent: _propTypes.PropTypes.elementType,
  name: _propTypes.PropTypes.string,
  selected: _propTypes.PropTypes.bool,
  title: _propTypes.PropTypes.string,
  variant: _propTypes.PropTypes.string.isRequired
};
Contents.defaultProps = {
  children: undefined,
  description: undefined,
  link: undefined,
  linkComponent: undefined,
  name: undefined,
  selected: false,
  title: undefined
};
var _default = Contents;
exports["default"] = _default;